import { render } from "./HeroiconsOutlineMail.vue?vue&type=template&id=0deb82a6"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMail.vue"]])

export default __exports__